<div>
	<div *ngIf="showLoader"
		class="row spinner-row"
		[ngClass]="{'white-theme': theme==='white',
					'blue-theme': theme==='blue'}">
		<vtr-spinner></vtr-spinner>
	</div>
	<label id="{{onOffSwitchId+'_toggleMain'}}"
		class="pb-1 pl-1 checkbox"
		[ngClass]="{'switch-disable': isSwitchDisable, 'white-theme': theme==='white', 'blue-theme': theme==='blue'}"
		#toggleMain
		(click)="toggleMain.focus()"
		[hidden]="showLoader"
		[tabindex]="disabled?-1:tabIndex"
		[attr.aria-checked]="value"
		[attr.aria-label]="ariaLabel"
		[attr.aria-disabled]="disabled"
		role="switch"
		(keydown.enter)="onChange(toggle)"
		(keyup.enter)="sendChangeEvent(toggle)">
		<input type="checkbox"
			#toggle
			tabindex="-1"
			id="{{onOffSwitchId+'_checkbox'}}"
			[name]="onOffSwitchId"
			class="switch"
			[ngClass]="{'wifi-checked': value===true}"
			[value]="value"
			[checked]="value"
			[disabled]="disabled"
			[readonly]="readonly"
			aria-hidden="true"
			[attr.aria-checked]="value"
			[attr.aria-disabled]="disabled"
			[attr.aria-readonly]="readonly"
			(change)="onChange(toggle)" />
		<span class="switch {{ size }}"
			id="{{onOffSwitchId}}{{value?'_on_sizeStopProp':'_off_sizeStopProp'}}"
			aria-hidden="true"
			(click)="stopPropagation($event);"
			(keydown.enter)="stopPropagation($event);">
			<small></small>
		</span>
	</label>
</div>
